import Ping from './ping';

export default class ValidateEmail {
	validateEmail(el) {
		this.setProps(el);
		const returnValue = this.sendRequest();
		return returnValue;
	}

	setProps(el) {
		this.el = el;
		this.apiEndpoint = el?.dataset?.apiEndpoint;
		this.pingHeading = null;
		this.pingBody = null;
		this.emoji = null;
		this.token = el.querySelector("input[name='EmailCheckInfo.Token']")?.value;
		this.antiForgeryToken = el.dataset?.antiForgeryToken;
		this.form = {
			EmailAddress: el.querySelector("input[name='Contact.EmailAddress']")?.value,
			Key: el.querySelector("input[name='EmailCheckInfo.Key']").value,
		};
	}

	sendRequest() {
		const apiBase = '/umbraco/api/';
		const xhr = new XMLHttpRequest();
		xhr.open('POST', `${apiBase}${this.apiEndpoint}`, false);
		xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
		xhr.setRequestHeader('Culture', document.documentElement.lang);
		xhr.setRequestHeader('RequestVerificationToken', this.antiForgeryToken);
		if (this.token !== null && this.token !== undefined) {
			xhr.withCredentials = true;
			xhr.setRequestHeader('Authorization', `Bearer ${this.token}`);
		}
		return this.handleSyncRequest(xhr);
	}

	handleSyncRequest(xhr) {
		try {
			// send the collected data as JSON
			xhr.send(JSON.stringify(this.form));

			const returnValue = this.handleRequestResponse(xhr);
			return returnValue;
		} catch {
			Ping.createSadPing();
			return false;
		}
	}

	// eslint-disable-next-line class-methods-use-this
	handleRequestResponse(xhr) {
		let pingHeading;
		let pingBody;
		let returnValue = false;
		const jsonResponse = JSON.parse(xhr.response);
		if (jsonResponse != null && jsonResponse.ping) {
			pingHeading = jsonResponse.ping.pingHeading;
			pingBody = jsonResponse.ping.pingBody;
		}
		if (xhr.status >= 200 && xhr.status < 300) {
			returnValue = true;
		}
		if (xhr.status === 400) {
			window.dispatchEvent(new CustomEvent('return-false'));
			// show what is wrong with the form
			Ping.createMehPing(pingHeading, pingBody);
		}
		if (xhr.status === 403) {
			window.dispatchEvent(new CustomEvent('return-false'));
			Ping.createMehPing(pingHeading, pingBody);
		}
		// seems a 500 does not land in the onError - TODO: check this
		if (xhr.status === 500) {
			window.dispatchEvent(new CustomEvent('return-false'));
			Ping.createSadPing(pingHeading, pingBody);
		}
		return returnValue;
	}
}
